export var TooltipClass;
(function (TooltipClass) {
    TooltipClass["MAIN"] = "sds-tooltip";
    TooltipClass["BASIC"] = "sds-tooltip--basic";
    TooltipClass["UP"] = "sds-tooltip--up";
    TooltipClass["UP_LEFT"] = "sds-tooltip--up-left";
    TooltipClass["UP_RIGHT"] = "sds-tooltip--up-right";
    TooltipClass["DOWN"] = "sds-tooltip--down";
    TooltipClass["DOWN_LEFT"] = "sds-tooltip--down-left";
    TooltipClass["DOWN_RIGHT"] = "sds-tooltip--down-right";
    TooltipClass["LEFT"] = "sds-tooltip--left";
    TooltipClass["LEFT_UP"] = "sds-tooltip--left-up";
    TooltipClass["LEFT_DOWN"] = "sds-tooltip--left-down";
    TooltipClass["RIGHT"] = "sds-tooltip--right";
    TooltipClass["RIGHT_UP"] = "sds-tooltip--right-up";
    TooltipClass["RIGHT_DOWN"] = "sds-tooltip--right-down";
    TooltipClass["HOVERED"] = "sds-tooltip-hovered";
})(TooltipClass || (TooltipClass = {}));
export function getClass(placement) {
    switch (placement) {
        case 'top':
            return TooltipClass.UP;
        case 'top-start':
            return TooltipClass.UP_LEFT;
        case 'top-end':
            return TooltipClass.UP_RIGHT;
        case 'bottom':
            return TooltipClass.DOWN;
        case 'bottom-start':
            return TooltipClass.DOWN_LEFT;
        case 'bottom-end':
            return TooltipClass.DOWN_RIGHT;
        case 'left':
            return TooltipClass.LEFT;
        case 'left-start':
            return TooltipClass.LEFT_UP;
        case 'left-end':
            return TooltipClass.LEFT_DOWN;
        case 'right':
            return TooltipClass.RIGHT;
        case 'right-start':
            return TooltipClass.RIGHT_UP;
        case 'right-end':
            return TooltipClass.RIGHT_DOWN;
        default:
            return TooltipClass.UP;
    }
}
